"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _commonConstants = require("../../../../utils/common-constants");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.general-tab-header-class .header-class {\n  margin-top: 2rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #a8a8a8; }\n  .general-tab-header-class .header-class .margin-top-32 {\n    margin-top: 2rem; }\n  .general-tab-header-class .header-class .margin-top-8 {\n    margin-top: 0.5rem; }\n";
  var fileName = "compone_General";
  var element = document.querySelector("style[data-sass-component='compone_General']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var PolicyViewGenerals = function PolicyViewGenerals(_ref) {
  var generalData = _ref.generalData,
      translatedStrings = _ref.translatedStrings,
      viewPolicyHeaders = _ref.viewPolicyHeaders,
      consumer = _ref.consumer;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.headerClass
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "pageSectionHeader"
  }, " ", viewPolicyHeaders === null || viewPolicyHeaders === void 0 ? void 0 : viewPolicyHeaders.general, " ")), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", translatedStrings === null || translatedStrings === void 0 ? void 0 : translatedStrings.policyName, " "), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, (generalData === null || generalData === void 0 ? void 0 : generalData.name) || (translatedStrings === null || translatedStrings === void 0 ? void 0 : translatedStrings.noneText)))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", translatedStrings === null || translatedStrings === void 0 ? void 0 : translatedStrings.description, " "), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, (generalData === null || generalData === void 0 ? void 0 : generalData.description) || (translatedStrings === null || translatedStrings === void 0 ? void 0 : translatedStrings.noneText)))), consumer !== _commonConstants.papServiceConsumer && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", translatedStrings === null || translatedStrings === void 0 ? void 0 : translatedStrings.accessType, " "), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, (generalData === null || generalData === void 0 ? void 0 : generalData.accessType) || (translatedStrings === null || translatedStrings === void 0 ? void 0 : translatedStrings.noneText)))));
};

PolicyViewGenerals.propTypes = {
  generalData: _propTypes.default.object,
  translatedStrings: _propTypes.default.object,
  viewPolicyHeaders: _propTypes.default.shape({
    general: _propTypes.default.string,
    members: _propTypes.default.string,
    generic: _propTypes.default.string,
    approvals: _propTypes.default.string
  }),
  consumer: _propTypes.default.string
};
var _default = PolicyViewGenerals;
exports.default = _default;